<template>
  <v-card id="detail-page" class="main-bg pb-0">
    <v-card-text class="pt-4">
      <v-container fluid class="pa-4">
        <template v-if="bookingLoading">
          <v-row
            style="height: 80vh"
            class="text-center"
            align-content="center"
          >
            <v-col cols="12">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col cols="12">
              <v-icon
                class="pa-1 rounded-lg mr-3"
                color="#0163e0"
                style="background-color: #f3f3f5"
                @click="onBack()"
                >mdi-chevron-left</v-icon
              >
              <b class="bc"
                ><span
                  class="text-link text-decoration-underline"
                  @click="onBack()"
                  >หน้ารวมใบงาน</span
                >
                / <span class="bc--current">{{ bookingItem.bookingNo }}</span></b
              >
            </v-col>
          </v-row>
          <v-row align="center" no-gutters>
            <template
              v-if="
                !this.$vuetify.breakpoint.sm && !this.$vuetify.breakpoint.xs
              "
            >
              <v-col class="mt-4"
                ><v-chip class="mx-1" style="background-color: #f3f3f5">
                  <b :style="'color:' + bookingItem.statusColorCode">{{
                    bookingItem.statusName
                  }}</b>
                </v-chip>
                <v-chip
                  v-if="bookingItem.rating"
                  class="mx-1 pl-1"
                  style="background-color: #f3f3f5"
                >
                  <v-icon class="mr-1" color="#FFD233">mdi-star</v-icon>
                  <b style="color: #0163e0">{{ bookingItem.rating }} / 5</b>
                </v-chip></v-col
              >
              <v-spacer></v-spacer>
              <template v-if="bookingItem.statusCode === 'PENDING'">
                <v-btn
                  :disabled="bookingLoading"
                  class="mr-4 hidden-sm-and-down"
                  height="44"
                  color="primary"
                  outlined
                  dark
                  elevation="0"
                  @click="onClickChangeAppointment()"
                >
                  เปลี่ยนเวลานัด
                </v-btn>
                <v-btn
                  :disabled="bookingLoading"
                  class="mr-4 hidden-sm-and-down"
                  height="44"
                  color="primary"
                  dark
                  elevation="0"
                  @click="onClickChangeStatus('CONFIRM')"
                >
                  ยืนยันรับงาน
                </v-btn>
                <v-btn
                  :disabled="bookingLoading"
                  class="mr-4 hidden-sm-and-down"
                  height="44"
                  color="#D80000"
                  dark
                  elevation="0"
                  @click="onClickChangeStatus('CANCELED')"
                >
                  ปฏิเสธงาน
                </v-btn>
              </template>
              <template v-else-if="bookingItem.statusCode === 'CONFIRM'">
                <v-btn
                :disabled="bookingLoading"
                  class="mr-4 hidden-sm-and-down"
                  height="44"
                  color="primary"
                  dark
                  elevation="0"
                  @click="onClickChangeStatus('IN-PROGRESS')"
                >
                  เริ่มงาน
                </v-btn>
              </template>
              <template v-else-if="bookingItem.statusCode === 'IN-PROGRESS'">
                <v-btn
                :disabled="bookingLoading"
                  class="mr-4 hidden-sm-and-down"
                  height="44"
                  color="primary"
                  dark
                  elevation="0"
                  @click="onClickChangeStatus('NOT_REVIEW')"
                >
                  จบงาน
                </v-btn>
              </template>
              <template v-else> </template>
            </template>
            <template v-else>
              <v-col class="text-center my-2">
                <v-chip class="mx-1" style="background-color: #f3f3f5">
                  <b :style="'color:' + bookingItem.statusColorCode">{{
                    bookingItem.statusName
                  }}</b>
                </v-chip>
                <v-chip
                  v-if="bookingItem.rating"
                  class="mx-1 pl-1"
                  style="background-color: #f3f3f5"
                >
                  <v-icon class="mr-1" color="#FFD233">mdi-star</v-icon>
                  <b style="color: #0163e0">{{ bookingItem.rating }} / 5</b>
                </v-chip>
              </v-col>
            </template>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" class="pa-0">
              <v-tabs id="commercial-service-booking-detail-tabs" v-model="tab">
                <v-tab key="InformationKey"
                  ><span class="tabs-title">ข้อมูลใบงาน</span></v-tab
                >
                <v-tab key="HistoryKey"
                  ><span class="tabs-title">ประวัติสถานะใบงาน</span></v-tab
                >
                <v-tabs-items :value="tab">
                  <v-tab-item key="InformationKey">
                    <information-page
                      ref="informationPage"
                      :booking="bookingItem"
                    ></information-page>
                  </v-tab-item>
                  <v-tab-item key="HistoryKey">
                    <history-page
                      ref="historyPage"
                      :histories="bookingItem.statusHistory"
                    ></history-page>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
            </v-col>
          </v-row>

          <v-row class="hidden-md-and-up">
            <template v-if="bookingItem.statusCode === 'PENDING'">
              <v-col cols="12" class="py-2">
                <v-btn
                :disabled="bookingLoading"
                  color="primary"
                  height="44"
                  outlined
                  dark
                  x-large
                  block
                  @click="onClickChangeAppointment()"
                >
                  เปลี่ยนเวลานัด
                </v-btn>
              </v-col>
              <v-col cols="12" class="py-2"
                ><v-btn
                :disabled="bookingLoading"
                  color="#D80000"
                  height="44"
                  dark
                  x-large
                  block
                  @click="onClickChangeStatus('CANCELED')"
                >
                  ปฏิเสธงาน
                </v-btn></v-col
              >
              <v-col cols="12" class="py-2"
                ><v-btn
                :disabled="bookingLoading"
                  color="primary"
                  height="44"
                  dark
                  x-large
                  block
                  @click="onClickChangeStatus('CONFIRM')"
                >
                  ยืนยันรับงาน
                </v-btn></v-col
              >
            </template>
            <template v-else-if="bookingItem.statusCode === 'CONFIRM'">
              <v-col cols="12" class="py-2"
                ><v-btn
                :disabled="bookingLoading"
                  color="primary"
                  height="44"
                  dark
                  x-large
                  block
                  @click="onClickChangeStatus('IN-PROGRESS')"
                >
                  เริ่มงาน
                </v-btn></v-col
              >
            </template>
            <template v-else-if="bookingItem.statusCode === 'IN-PROGRESS'">
              <v-col cols="12" class="py-2"
                ><v-btn
                :disabled="bookingLoading"
                  color="primary"
                  height="44"
                  dark
                  x-large
                  block
                  @click="onClickChangeStatus('NOT_REVIEW')"
                >
                  จบงาน
                </v-btn></v-col
              >
            </template>
            <template v-else> </template>
          </v-row>
        </template>
      </v-container>

      <v-dialog
        persistent
        v-model="isShowChangeAppointmentModal"
        scrollable
        transition="dialog-bottom-transition"
        max-width="75%"
      >
        <change-appointment-modal
          v-if="isShowChangeAppointmentModal"
          :visible="isShowChangeAppointmentModal"
          :appointment="bookingItem.contactor.appointedAt"
          @cancelled="onCloseModal()"
          @saved="
            onCloseModal();
            confirmChangeAppointment($event);
          "
        >
        </change-appointment-modal>
      </v-dialog>

      <v-dialog
        persistent
        v-model="isShowConfirmModal"
        scrollable
        transition="dialog-bottom-transition"
        max-width="75%"
      >
        <confirm-modal
          v-if="isShowConfirmModal"
          :visible="isShowConfirmModal"
          :title="getModalDisplayText().title"
          :description="getModalDisplayText().description"
          @cancelled="onCloseModal()"
          @saved="
            onCloseModal();
            confirmChangeStatus();
          "
        >
        </confirm-modal>
      </v-dialog>

      <v-dialog
        persistent
        v-model="isShowConfirmCancelModal"
        scrollable
        transition="dialog-bottom-transition"
        max-width="75%"
      >
        <confirm-cancel-modal
          v-if="isShowConfirmCancelModal"
          :visible="isShowConfirmCancelModal"
          title="ปฏิเสธงาน"
          description="โปรดระบุเหตุผลในการปฏิเสธงาน"
          @cancelled="onCloseModal()"
          @saved="
            onCloseModal();
            confirmCancelBooking($event);
          "
        >
        </confirm-cancel-modal>
      </v-dialog>

      <!-- <Footer></Footer> -->
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import {
  BOOKING_REQUEST,
  BOOKING_CHANGE_APPOINTMENT_REQUEST,
  BOOKING_UPDATE_STATUS_REQUEST,
  BOOKING_CANCEL_REQUEST,
} from "@/store/actions/booking";
import { LPA_HOME } from "@/router/constant";
import InformationPage from "@/components/lpa/InformationPage.vue";
import HistoryPage from "@/components/lpa/HistoryPage.vue";
// import Footer from "@/components/Footer.vue";
import ChangeAppointmentModal from "@/components/lpa/ChangeAppointmentModal.vue";
import ConfirmModal from "@/components/lpa/ConfirmModal.vue";
import ConfirmCancelModal from "@/components/lpa/ConfirmCancelModal.vue";
import { BookingStatuses, CancelBookingId } from "@/common/api/config";

export default {
  components: {
    InformationPage,
    HistoryPage,
    // Footer,
    ChangeAppointmentModal,
    ConfirmModal,
    ConfirmCancelModal,
  },
  computed: {
    ...mapGetters(["bookingItem", "bookingLoading"]),
  },
  data() {
    return {
      tab: 0,
      isPageLoading: false,
      pageLimit: 20,
      pages: 0,
      page: 1,
      isShowChangeAppointmentModal: false,
      isShowConfirmModal: false,
      isShowConfirmCancelModal: false,
      appointedAt: null,
      selectedChangedStatusCode: null,
      vTableHeaders: [
        { text: "ใบงาน", value: "bookingNo" },
        {
          text: "ชื่อผู้โหวต",
          value: "customerName",
        },
        { text: "วันที่โหวต", value: "displayCreatedAt" },
        { text: "คะแนน", value: "rating" },
      ],
      list: [
        {
          customerName: "อนุชิต จงจอหอ",
          bookingNo: "BNK-01",
          displayCreatedAt: "24 พฤษภาคม 2023, 12.03 น.",
          rating: 5,
        },
        {
          customerName: "อนุชิต จิตสังหารโหด",
          bookingNo: "BNK-48",
          displayCreatedAt: "23 พฤษภาคม 2023, 12.03 น.",
          rating: 4,
        },
      ],
      isShowBookingModal: false,
    };
  },
  async created() {
    // this.selectedChangedStatus = null;
    await this.fetch();
  },
  methods: {
    async fetch() {
      await this.$store.dispatch(BOOKING_REQUEST, {
        token: this.$route.query.token,
        bookingId: this.$route.params.id,
      });
    },
    onClickChangeAppointment() {
      console.log("onClickChangeAppointment");
      this.isShowChangeAppointmentModal = true;
    },
    onCloseModal() {
      this.isShowChangeAppointmentModal = false;
      this.isShowConfirmModal = false;
      this.isShowConfirmCancelModal = false;
    },
    onClickChangeStatus(statusCode) {
      console.log("onClickChangeStatus", statusCode);
      this.selectedChangedStatusCode = statusCode;

      if (statusCode === "CANCELED") {
        this.isShowConfirmCancelModal = true;
      } else {
        this.isShowConfirmModal = true;
      }
    },
    onClickDecline() {
      console.log("onClickDecline");
    },
    onCancel() {
      this.$emit("cancelled");
    },
    saved() {
      this.$emit("saved");
    },
    async confirmChangeAppointment(value) {
      console.log("value", value);
      await this.$store
        .dispatch(BOOKING_CHANGE_APPOINTMENT_REQUEST, {
          token: this.$route.query.token,
          bookingId: this.$route.params.id,
          payload: {
            AppointedAt: value,
          },
        });
      await this.fetch();
    },
    getModalDisplayText() {
      const status = BookingStatuses.find(
        (v) => v.code === this.selectedChangedStatusCode
      );

      console.log('getModalDisplayText', status.code);

      let statusDisplay = '';

      switch (status.code) {
        case 'IN-PROGRESS':
          statusDisplay = 'เริ่มงาน';
          break;
        
        case 'NOT_REVIEW': 
          statusDisplay = 'จบงาน';
          break;
      
        default:
          statusDisplay = status.display;
          break;
      }

      return {
        title: statusDisplay,
        description: `คุณต้องการ ${statusDisplay} ใช่หรือไม่`,
      };
    },
    async confirmChangeStatus() {
      const statusId = BookingStatuses.find(
        (v) => v.code === this.selectedChangedStatusCode
      ).objectId;
      if (statusId) {
        await this.$store
          .dispatch(BOOKING_UPDATE_STATUS_REQUEST, {
            token: this.$route.query.token,
            bookingId: this.$route.params.id,
            payload: {
              StatusId: statusId,
            },
          })
          .then(() => {
            this.selectedChangedStatusCode = null;
          });

        await this.fetch();
      }
    },
    async confirmCancelBooking(value) {
      // console.log('CancelBookingId', CancelBookingId, value);

      if (value) {
        await this.$store
          .dispatch(BOOKING_CANCEL_REQUEST, {
            token: this.$route.query.token,
            bookingId: this.$route.params.id,
            payload: {
              ReasonId: CancelBookingId,
              Reason: value,
            },
          })
          .then(() => {
            this.selectedChangedStatusCode = null;
          });
        await this.fetch();
      }
    },
    onBack() {
      const storeData = JSON.parse(localStorage.getItem('vendor_app'));
      this.$router.push({
        name: LPA_HOME,
        params: {
          env: storeData.system
        },
        query: { 
          token: this.$route.query.token 
        },
      });
      // this.$router.push({ name: HOME, params: { token: "TOKEN" } });
    },
  },
};
</script>

<style lang="scss" scope>
#commercial-service-booking-detail-tabs .v-tabs-bar {
  border-bottom: 1px solid #eaeaea;
}
// .v-btn {
//   height: 48px !important;
// }
.text-link {
  cursor: pointer;
}
.bc {
  color: #a5a5a5;
  font-size: 18px;
}
.bc--current {
  color: #0163e0;
}
.letter-spacing-1 {
  letter-spacing: 1px !important;
}
#detail-page {
  .v-btn__content {
    font-weight: bold;
    font-size: 14px !important;
  }
  .v-data-table tr th,
  td {
    border-bottom: 1px solid #eaeaea !important;
  }
}
</style>